/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { TicketEventStatus } from './TicketEventStatus';
import {
    TicketEventStatusFromJSON,
    TicketEventStatusFromJSONTyped,
    TicketEventStatusToJSON,
    TicketEventStatusToJSONTyped,
} from './TicketEventStatus';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PublicTicketEvent
 */
export interface PublicTicketEvent {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof PublicTicketEvent
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof PublicTicketEvent
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof PublicTicketEvent
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof PublicTicketEvent
     */
    startsAtUtc: Date | null;
    /**
     * 
     * @type {string}
     * @memberof PublicTicketEvent
     */
    venue: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicTicketEvent
     */
    description: string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicTicketEvent
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof PublicTicketEvent
     */
    currency: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PublicTicketEvent
     */
    remaining: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PublicTicketEvent
     */
    maxPerOrder: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {TicketEventStatus}
     * @memberof PublicTicketEvent
     */
    status: TicketEventStatus;
    /**
     * 
     * @type {Date}
     * @memberof PublicTicketEvent
     */
    salesEndUtc: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTicketEvent
     */
    purchasable: boolean;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof PublicTicketEvent
     */
    quantityDealPayFor?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof PublicTicketEvent
     */
    quantityDealReceive?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof PublicTicketEvent
     */
    locationName?: string | null;
}



/**
 * Check if a given object implements the PublicTicketEvent interface.
 */
export function instanceOfPublicTicketEvent(value: object): value is PublicTicketEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('startsAtUtc' in value) || value['startsAtUtc'] === undefined) return false;
    if (!('venue' in value) || value['venue'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('remaining' in value) || value['remaining'] === undefined) return false;
    if (!('maxPerOrder' in value) || value['maxPerOrder'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('salesEndUtc' in value) || value['salesEndUtc'] === undefined) return false;
    if (!('purchasable' in value) || value['purchasable'] === undefined) return false;
    return true;
}

export function PublicTicketEventFromJSON(json: any): PublicTicketEvent {
    return PublicTicketEventFromJSONTyped(json, false);
}

export function PublicTicketEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicTicketEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'slug': json['slug'],
        'name': json['name'],
        'startsAtUtc': (json['startsAtUtc'] == null ? null : new Date(json['startsAtUtc'])),
        'venue': json['venue'],
        'description': json['description'],
        'price': json['price'],
        'currency': json['currency'],
        'remaining': ApiUserTasksGetPageParameterFromJSON(json['remaining']),
        'maxPerOrder': ApiUserTasksGetPageParameterFromJSON(json['maxPerOrder']),
        'status': TicketEventStatusFromJSON(json['status']),
        'salesEndUtc': (json['salesEndUtc'] == null ? null : new Date(json['salesEndUtc'])),
        'purchasable': json['purchasable'],
        'quantityDealPayFor': json['quantityDealPayFor'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['quantityDealPayFor']),
        'quantityDealReceive': json['quantityDealReceive'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['quantityDealReceive']),
        'locationName': json['locationName'] == null ? undefined : json['locationName'],
    };
}

export function PublicTicketEventToJSON(json: any): PublicTicketEvent {
    return PublicTicketEventToJSONTyped(json, false);
}

export function PublicTicketEventToJSONTyped(value?: PublicTicketEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'slug': value['slug'],
        'name': value['name'],
        'startsAtUtc': value['startsAtUtc'] == null ? value['startsAtUtc'] : value['startsAtUtc'].toISOString(),
        'venue': value['venue'],
        'description': value['description'],
        'price': value['price'],
        'currency': value['currency'],
        'remaining': ApiUserTasksGetPageParameterToJSON(value['remaining']),
        'maxPerOrder': ApiUserTasksGetPageParameterToJSON(value['maxPerOrder']),
        'status': TicketEventStatusToJSON(value['status']),
        'salesEndUtc': value['salesEndUtc'] == null ? value['salesEndUtc'] : value['salesEndUtc'].toISOString(),
        'purchasable': value['purchasable'],
        'quantityDealPayFor': ActorActivityRecordActorUserIdToJSON(value['quantityDealPayFor']),
        'quantityDealReceive': ActorActivityRecordActorUserIdToJSON(value['quantityDealReceive']),
        'locationName': value['locationName'],
    };
}

